import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthState } from '../../store/auth/auth.state';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard {
  constructor(
    private store: Store,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(AuthState.getToken).pipe(
      map(token => {        
        if (!token) {        
          return true;
        }

        const url = this.router.url;
        if(url.includes('reset-password')){
          console.log('PublicGuard - token is true, redirecting to admin' ,this.router.url);
          console.log('PublicGuard - url', url);
          console.log('PublicGuard - token', token);
          return true;
        }
        return this.router.createUrlTree(['/modulos']);
      })
    );
  }
}
